import { useMediaQuery } from 'react-responsive';

const MOBILE_BREAKPOINT = '640px';

export const useMobile = () => {
  const isMobile = useMediaQuery({ query: `(max-width:${MOBILE_BREAKPOINT}` });

  return { isMobile };
};
